// Jefes inmediatos disponibles para horas extra/novedades (por el momento,
// lista fija — no se resuelve contra la base de datos). Compartido entre el
// formulario del portal público (src/Components/Auth/login.jsx) y el
// formulario interno "Registrar extra" de Contabilidad
// (src/pages/modules/ContabilidadPanel.jsx) para que ambos guarden siempre
// la misma cédula por jefe.
//
// La cédula (responsible_cedula en admin_users) es indispensable: la
// aprobación de horas extra (isBossForRow en ContabilidadPanel.jsx, y
// digits_match() en overtime_extras.php) compara la cédula del usuario
// logueado contra immediate_boss_id, no contra el nombre — un registro
// guardado solo con el nombre (sin id) nunca aparece como pendiente para
// ese jefe, aunque el nombre coincida exactamente.
export const IMMEDIATE_BOSS_OPTIONS = [
  { name: 'JORGE HERNAN CARDONA TORRES', cedula: '1053806989' },
  { name: 'CRISTIAN DAVID URBANO HOYOS', cedula: '1061789585' },
  { name: 'VILMA ASCENCION OCHOA VARGAS', cedula: '63456711' },
  { name: 'GEORDYN FABIAN PARRA VANEGAS', cedula: '1090482255' },
  { name: 'CRISTIAN CAMILO PRIETO PULIDO', cedula: '1024537172' },
  { name: 'ROMAN FELIPE OROZCO', cedula: '1088256208' },
];
